/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Logging_Warmup_RemoveInputs */

const en_us2_workout_logging_warmup_remove = /** @type {(inputs: Workout_Logging_Warmup_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove warm-up`)
};

const pt_br2_workout_logging_warmup_remove = /** @type {(inputs: Workout_Logging_Warmup_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remover aquecimento`)
};

const es_419_workout_logging_warmup_remove = /** @type {(inputs: Workout_Logging_Warmup_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quitar calentamiento`)
};

const pt_pt2_workout_logging_warmup_remove = /** @type {(inputs: Workout_Logging_Warmup_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remover aquecimento`)
};

const fr_fr2_workout_logging_warmup_remove = /** @type {(inputs: Workout_Logging_Warmup_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retirer l'échauffement`)
};

const de_de2_workout_logging_warmup_remove = /** @type {(inputs: Workout_Logging_Warmup_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aufwärmen entfernen`)
};

const it_it2_workout_logging_warmup_remove = /** @type {(inputs: Workout_Logging_Warmup_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rimuovi riscaldamento`)
};

/**
* | output |
* | --- |
* | "Remove warm-up" |
*
* @param {Workout_Logging_Warmup_RemoveInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_logging_warmup_remove = /** @type {((inputs?: Workout_Logging_Warmup_RemoveInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Logging_Warmup_RemoveInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_logging_warmup_remove(inputs)
	if (locale === "es-419") return es_419_workout_logging_warmup_remove(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_logging_warmup_remove(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_logging_warmup_remove(inputs)
	if (locale === "de-DE") return de_de2_workout_logging_warmup_remove(inputs)
	if (locale === "it-IT") return it_it2_workout_logging_warmup_remove(inputs)
	return en_us2_workout_logging_warmup_remove(inputs)
});
export { workout_logging_warmup_remove as "workout-logging.warmup_remove" }